import axios from 'axios';
import { API_BASE_URL } from '@/config';
import { useState, useEffect } from 'react';

export const useFetchSmartPayables = ({ organizationId }) => {
  const [smartPayables, setSmartPayables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSmartPayables = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/smartpayables`, {
        params: {
          organizationId: organizationId ? organizationId : '',
        },
      });
      setSmartPayables(response.data || []);
    } catch (error) {
      console.error('Error fetching SmartPayables:', error);
      setError('Error fetching SmartPayables');
      setSmartPayables([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSmartPayables();
  }, [organizationId]);

  return { smartPayables, loading, error, refetch: fetchSmartPayables };
};
